import { adminApi } from './adminClient'
import { useSessionStore } from '../stores/session'

export interface AdminSessionAllowedAction {
  action_key: string
  resource_type: string
  resource_id?: string
  field_classes: number
  max_expires_at?: string
}

export interface AdminTemporaryGrant {
  id: string
  action_key: string
  resource_type: string
  resource_id?: string
  expires_at: string
  one_use: boolean
}

export interface AdminSessionView {
  principal: { id: string }
  roles: string[]
  data_scopes: string[]
  allowed_actions: AdminSessionAllowedAction[]
  temporary_grants: AdminTemporaryGrant[]
  csrf_token: string
  permission_epoch: number
  environment: string
  build_id: string
}

export const adminSessionApi = {
  getSession(signal?: AbortSignal) {
    return adminApi.get<AdminSessionView>('/admin/v1/session', signal)
  },
}

function syncCsrfToken(token: string) {
  let element = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  if (!token) {
    element?.remove()
    return
  }
  if (!element) {
    element = document.createElement('meta')
    element.name = 'csrf-token'
    document.head.append(element)
  }
  element.content = token
}

export function applyAdminSession(view: AdminSessionView) {
  const store = useSessionStore()
  const temporaryGrants = view.temporary_grants ?? []
  store.environment = view.environment
  store.dataScope = view.data_scopes.join(' / ') || '未分配数据域'
  store.permissionEpoch = view.permission_epoch
  store.temporaryGrantExpiresAt = temporaryGrants
    .map((grant) => grant.expires_at)
    .filter(Boolean)
    .sort()[0] ?? null
  store.allowedActions = view.allowed_actions.map((action) => ({
    actionKey: action.action_key,
    resourceType: action.resource_type,
    resourceId: action.resource_id,
    expiresAt: action.max_expires_at,
  }))
  store.temporaryGrants = temporaryGrants.map((grant) => ({
    id: grant.id,
    actionKey: grant.action_key,
    resourceType: grant.resource_type,
    resourceId: grant.resource_id,
    expiresAt: grant.expires_at,
    oneUse: grant.one_use,
  }))
  syncCsrfToken(view.csrf_token)
}
